import React from "react";
import Settings from "components/dashboard/Settings";
import SettingsDialogShell from "./SettingsDialogShell";

/** Settings on top of whatever page the user is on, opened from the account menu. */
const SettingsDialog = ({ open, onClose }) => (
  <SettingsDialogShell open={open} onClose={onClose}>
    {/* No `open &&` guard: Dialog already unmounts this once it has closed, so it
        still doesn't load billing and MFA state for nothing, and a guard would
        blank the settings while the dialog fades out. */}
    <Settings embedded />
  </SettingsDialogShell>
);

export default SettingsDialog;
